import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard, { Penalty } from "./scoreboard";
import { upperFirst } from "./util";

export class PlayerPenalty extends Handler {
    private playerNumber: string = "";
    private time: string = "";
    private collectingNumber: boolean = false;
    private addPenalty: (penalty: Penalty) => void = (penalty: Penalty) => {};
    private num: number = 0;

    constructor(private side: "home" | "guest") {
        super();
    }

    boot(): void {
        this.playerNumber = "••";
        this.time = "••:••";
        this.collectingNumber = true;

        const sideF = upperFirst(this.side) as "Home" | "Guest";
        this.addPenalty = scoreboard[`add${sideF}Penalty`].bind(scoreboard);
        this.num = scoreboard[`${this.side}Penalties`].length + 1;

        display.line1(`${this.side.toUpperCase()} PLYR/PEN`);

        this.update();
    }

    update(): void {
        const playerStar = this.collectingNumber ? "*" : " ";
        const timeStar = this.collectingNumber ? " " : "*";

        display.line2(
            `${this.num} P${this.playerNumber}${playerStar} PN ${this.time}${timeStar}`
        );
    }

    onKeypad(num: string): void {
        if (this.collectingNumber) {
            this.playerNumber = this.playerNumber.substring(1) + num;
        } else {
            this.time = `${this.time.charAt(1)}${this.time.charAt(
                3
            )}:${this.time.charAt(4)}${num}`;
        }

        this.update();
    }

    onEnter(): void {
        if (this.collectingNumber) {
            this.collectingNumber = false;
            this.update();
        } else {
            clock.popHandler();
            const playerNumber = this.playerNumber.replaceAll("•", " ");
            const time = this.time.replaceAll("•", "0");
            const seconds = +time.substring(0, 2) * 60 + +time.substring(3, 5);
            this.addPenalty({
                playerNumber: +playerNumber,
                time: seconds * 1000,
            });
        }
    }

    onClear(): void {
        if (this.collectingNumber) {
            if (this.playerNumber == "••") {
                clock.popHandler();
            } else {
                this.playerNumber = "••";
                this.update();
            }
        } else {
            if (this.time == "••:••") {
                this.collectingNumber = true;
                this.update();
            } else {
                this.time = "••:••";
                this.update();
            }
        }
    }
}
